<script setup lang="ts">
  import { Text, IconLogo } from "@ui-kit";
  import { StatusBar } from "@src/components";
</script>

<template>
  <div class="forbidden-page" data-testid="forbidden-page">
    <StatusBar />
    <IconLogo class="forbidden-page__logo" />
    <div class="forbidden-page__content">
      <Text font="heading-H4">{{ $t("Ошибка") + " " + 403 }}</Text>
      <Text font="body-regular-16">{{ $t("Мы уже работаем над проблемой, скоро ее решим") }}</Text>
    </div>
  </div>
</template>

<style scoped>
  .forbidden-page {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .forbidden-page__logo {
    fill: var(--sf-base-icon-primary);
    margin: 0 auto;
    margin-top: 7px;
  }

  .forbidden-page__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 16px;
  }
</style>
